import useSWR from "swr";
import { api } from "../services";

const BASE_URL = "/system-admin/shift-codes";

export const useEmployeeShiftCode = ( query = {} ) => {
  const qs = new URLSearchParams(query).toString();
  const { data, isLoading, mutate } = useSWR(`${BASE_URL}?${qs}`, api.get);

  const create = async (data) => {
    const employeeShift = await api.post(BASE_URL, data);
    return employeeShift;
  };

  const getById = async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response;
  };

  const update = async (updatedData) => {
    const response = await api.put(`${BASE_URL}`, updatedData);
    return response;
  };


  return {
    isLoading,
    data: data,
    count: data?.length,
    mutate,
    create,
    update,
    getById
  };
};